import { svg } from 'lit';

const symbol = svg`<svg width="11" height="11" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><circle fill="#616161" cx="2.5" cy="2.5" r="2.5"/><circle fill="#BEBEBE" cx="8.5" cy="2.5" r="2.5"/><circle fill="#427457" cx="2.5" cy="8.5" r="2.5"/><circle fill="#80313D" cx="8.5" cy="8.5" r="2.5"/></g></svg>`;

export { symbol as default };
